// src/components/StepperNav.js
import React from "react";
import { Stepper, Step, StepLabel, Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const stepKeys = ["dates", "times", "link", "summary"];

function StepperNav() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const currentStep = stepKeys.findIndex((step) => location.pathname.includes(step));

  const handleStepChange = (index) => {
    navigate(`/trajectories/${stepKeys[index]}`);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ width: "100%", p: 2, paddingLeft: 3, paddingRight: 3 }}>
        <Stepper activeStep={currentStep} style={{ backgroundColor: "transparent" }}>
          {stepKeys.map((key, index) => (
            <Step key={key} onClick={() => handleStepChange(index)}>
              <StepLabel>{t(`trajectories.wizard.steps.${key}`)}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
}

export default StepperNav;
